import React from 'react';
import { Box, Grid, Modal } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

function TextModal(props) {
  const { open, content, handleClose } = props;
  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common text-modal">
        <Grid container>
          <Grid
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className="align-right"
            onClick={handleClose}
          >
            <CloseRoundedIcon />
          </Grid>

          <Grid xs={12} sm={12} md={12} lg={12}>
            <span>{content}</span>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
export default TextModal;
